import { useTranslation } from "react-i18next";
import { AltSymbolIcon } from "@scryerlabs/ui";
import { displayTicker } from "../../trading-strategies/tickers";

interface InstrumentsStrategy {
  chartedSymbol?: string | null;
  bullSymbol?: string | null;
  bearSymbol?: string | null;
}

/**
 * What a strategy charts, then what it trades: the bull side in green, the bear side in red. This is
 * what tells a strategy's long-only and long-and-short versions apart, since they share a name.
 * Compact puts both on one line, for a dropdown option.
 */
export function StrategyInstruments({
  strategy,
  compact = false,
}: {
  strategy: InstrumentsStrategy;
  compact?: boolean;
}) {
  const { t } = useTranslation("tradingStrategies");

  const charted = displayTicker(strategy.chartedSymbol);
  const bull = displayTicker(strategy.bullSymbol);
  const bear = displayTicker(strategy.bearSymbol);

  return (
    <div className={`d-flex ${compact ? "align-items-center gap-2" : "flex-column gap-1"} font-monospace small`}>
      {charted && <span>{charted}</span>}
      {(bull || bear) && (
        <span className="d-inline-flex align-items-center gap-2">
          <AltSymbolIcon label={t("traits.altSymbols")} size={compact ? 16 : 18} />
          <span>
            {bull && <span style={{ color: "var(--sl-positive)" }}>{bull}</span>}
            {bull && bear && <span className="text-body-secondary"> / </span>}
            {bear && <span style={{ color: "var(--sl-negative)" }}>{bear}</span>}
          </span>
        </span>
      )}
    </div>
  );
}
